<p>annual-study-hours works!</p>
